import { apiClient } from './client';
import type {
  Form,
  FormCreateInput,
  FormUpdateInput,
} from '../../types/entities';

export const formsApi = {
  /**
    * Get all forms for a tenant
    * GET /tenants/:tenantSlug/forms
    */
  getAllForTenant: async (tenantSlug: string): Promise<Form[]> => {
    return apiClient.get<Form[]>(`/tenants/${tenantSlug}/forms`);
  },

  /**
    * Get a single form by ID
    * GET /tenants/:tenantSlug/forms/:id
    */
  getById: async (tenantSlug: string, id: number): Promise<Form> => {
    return apiClient.get<Form>(`/tenants/${tenantSlug}/forms/${id}`);
  },

  /**
    * Create a new form
    * POST /tenants/:tenantSlug/forms
    */
  create: async (
    tenantSlug: string,
    data: FormCreateInput
  ): Promise<Form> => {
    return apiClient.post<Form>(`/tenants/${tenantSlug}/forms`, data);
  },

  /**
    * Update a form
    * PUT /tenants/:tenantSlug/forms/:id
    */
  update: async (
    tenantSlug: string,
    id: number,
    data: FormUpdateInput
  ): Promise<Form> => {
    return apiClient.put<Form>(
      `/tenants/${tenantSlug}/forms/${id}`,
      data
    );
  },

  /**
    * Delete a form
    * DELETE /tenants/:tenantSlug/forms/:id
    */
  delete: async (tenantSlug: string, id: number): Promise<void> => {
    return apiClient.delete<void>(`/tenants/${tenantSlug}/forms/${id}`);
  },
};
